/**
 * Structural rather than `d3.HierarchyNode<unknown>`, which the concrete node types are not
 * assignable to: `path` takes its own type as a parameter, so they are invariant in the datum.
 */
type Walkable<Node> = {
  depth: number;
  eachBefore: (callback: (node: Node) => void) => unknown;
};

/**
 * The nodes the Maximum depth setting leaves, in the order they are drawn and read.
 *
 * Depth-first pre-order — a node, then its subtree, then its next sibling — not `descendants()`,
 * which is breadth-first. This is the DOM order a screen reader browses and the order ArrowDown
 * walks, so the tree pattern requires it; see `moves down into the subtree it says it has`.
 */
export const toDrawnOrder = <Node extends Walkable<Node>>(
  root: Node,
  maxDepth: number
): Node[] => {
  const drawn: Node[] = [];
  root.eachBefore(node => {
    if (node === root) return;
    if (maxDepth > 0 && node.depth > maxDepth) return;
    drawn.push(node);
  });
  return drawn;
};
